import { render } from "./TabularDatasetBrowser.vue?vue&type=template&id=fd3e812c&scoped=true"
import script from "./TabularDatasetBrowser.vue?vue&type=script&lang=js"
export * from "./TabularDatasetBrowser.vue?vue&type=script&lang=js"

import "./TabularDatasetBrowser.vue?vue&type=style&index=0&id=fd3e812c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3e812c"]])

export default __exports__